/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectItemsForDailyTaskReportQueryResult } from '../../models/get-project-items-for-daily-task-report-query-result';

export interface ApiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Params {
  ReportId?: string;
}

export function apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsForDailyTaskReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet.PATH, 'get');
  if (params) {
    rb.query('ReportId', params.ReportId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectItemsForDailyTaskReportQueryResult>;
    })
  );
}

apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet.PATH = '/api/ProjectDailyTaskReports/GetProjectItemsForDailyTaskReport';
